import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Collapse,
  IconButton,
  Chip,
  Divider
} from '@mui/material';
import {
  ExpandMore,
  CheckCircle,
  HourglassEmpty
} from '@mui/icons-material';
import LogMessage from './LogMessage';

function ProviderCard({ providerName, data }) {
  const [expanded, setExpanded] = useState(false);

  const { status, amount, locations, logs } = data;

  return (
    <Card
      elevation={1}
      sx={{
        mb: 2,
        borderLeft: 3,
        borderColor: status === 'completed' ? 'success.main' : 'info.main'
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer'
          }}
          onClick={() => setExpanded(!expanded)}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            {status === 'completed' ? (
              <CheckCircle sx={{ color: 'success.main', fontSize: 20, mr: 1 }} />
            ) : (
              <HourglassEmpty sx={{ color: 'info.main', fontSize: 20, mr: 1 }} />
            )}
            <Typography sx={{ fontWeight: 600, mr: 2 }}>
              {providerName}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={`${locations || 0} locations`}
              size="small"
              variant="outlined"
            />
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                color: 'primary.main',
                fontFamily: '"Roboto Mono", monospace'
              }}
            >
              ${(amount || 0).toFixed(2)}
            </Typography>
            <IconButton
              size="small"
              sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s'
              }}
            >
              <ExpandMore />
            </IconButton>
          </Box>
        </Box>

        <Collapse in={expanded}>
          <Divider sx={{ my: 2 }} />
          <Box sx={{ mt: 2 }}>
            {logs && logs.length > 0 ? (
              logs.map((log, index) => (
                <LogMessage
                  key={index}
                  message={log.message}
                  type={log.type}
                  timestamp={log.timestamp}
                />
              ))
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                No detailed logs available
              </Typography>
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
}

export default ProviderCard;

